import type { PurchasePhotoType } from './SelectPhotoType';
import type { PhotoItemJson } from '@/types/domain/photo/entities/photoItemEntity';

/**
 * GroupDetailController
 */
export class GroupDetailController {
  private purchasePhotos: PurchasePhotoType[];

  private photoTypes: PhotoItemJson[];

  constructor(
    purchasePhotos: PurchasePhotoType[],
    photoTypes: PhotoItemJson[],
  ) {
    this.purchasePhotos = purchasePhotos;
    this.photoTypes = photoTypes;
  }

  /**
   * 選択写真のすべてにおいて１つでもtypeが選ばれているか
   * @returns すべて選択されているか
   */
  checkIsAllPurchasePhotoTypeSelected = () => {
    for (let i = 0; i < this.purchasePhotos.length; i += 1) {
      if (this.purchasePhotos[i].photoTypes.length === 0) {
        return false;
      }
    }
    return true;
  };

  /**
   * 商品別も含めた合計金額を計算する + 商品種類数を返却（購入数制限用）
   * @returns 合計金額
   */
  getTotalPrices = () => {
    let totalPrice = 0;
    let totalNumItems = 0; // 商品種類数
    const purchasePhotoTypeList = [];
    for (let i = 0; i < this.photoTypes.length; i += 1) {
      purchasePhotoTypeList.push({
        ...this.photoTypes[i],
        /** カウント */
        count: 0,
      });
    }
    for (let i = 0; i < this.purchasePhotos.length; i += 1) {
      for (let j = 0; j < this.purchasePhotos[i].photoTypes.length; j += 1) {
        const { num, type } = this.purchasePhotos[i].photoTypes[j];
        const photoType = this.photoTypes.find(
          (v) => v.photoItemId === type.photoItemId,
        );
        if (photoType) {
          totalPrice += photoType.price * num;
          const index = purchasePhotoTypeList.findIndex(
            (v) => v.photoItemId === photoType.photoItemId,
          );
          if (index >= 0) {
            purchasePhotoTypeList[index].count += num;
          }
        }
        if (num > 0) {
          totalNumItems += 1;
        }
      }
    }
    return {
      /** 合計価格 */
      totalPrice,
      /** 写真タイプごとの合計価格 */
      totalPricePhotoTypes: purchasePhotoTypeList,
      /** 合計アイテム数 */
      totalNumItems,
    };
  };

  /**
   * 指定の種別の全写真に対して追加・削除したものを返す
   * @param isAdd 追加するか
   * @param photoType 種別
   * @returns 更新値
   */
  addOrRemovePhotoTypeAll = (isAdd: boolean, photoType: PhotoItemJson) => {
    const newPhotos = [];
    for (let i = 0; i < this.purchasePhotos.length; i += 1) {
      const photo = { ...this.purchasePhotos[i] };
      const newTypeList: {
        type: PhotoItemJson;
        num: number;
      }[] = [];
      if (isAdd) {
        let isExist = false;
        for (let j = 0; j < photo.photoTypes.length; j += 1) {
          newTypeList.push({
            type: { ...photo.photoTypes[j].type },
            num: 1,
          });
          if (photo.photoTypes[j].type.photoItemId === photoType.photoItemId) {
            isExist = true;
          }
        }
        if (!isExist) {
          newTypeList.push({
            type: { ...photoType },
            num: 1,
          });
        }
      } else {
        for (let j = 0; j < photo.photoTypes.length; j += 1) {
          if (photo.photoTypes[j].type.photoItemId !== photoType.photoItemId) {
            newTypeList.push({
              type: { ...photo.photoTypes[j].type },
              num: 1,
            });
          }
        }
      }
      photo.photoTypes = newTypeList;
      newPhotos.push(photo);
    }
    return newPhotos;
  };

  /**
   * 指定した写真に対して指定した種別の追加・削除を行う
   * @param isAdd 追加するか
   * @param photoType 種別ID
   * @param photoId 写真ID
   * @returns 更新値
   */
  addOrRemovePhotoType = (
    isAdd: boolean,
    photoType: { type: PhotoItemJson, num: number },
    photoId: string,
  ) => {
    const newPhotos = [];
    for (let i = 0; i < this.purchasePhotos.length; i += 1) {
      const photo = { ...this.purchasePhotos[i] };
      if (this.purchasePhotos[i].id === photoId) {
        if (isAdd) {
          photo.photoTypes.push(photoType);
        } else {
          const newTypeList = [];
          for (let j = 0; j < photo.photoTypes.length; j += 1) {
            if (photo.photoTypes[j].type.photoItemId !== photoType.type.photoItemId) {
              newTypeList.push(photo.photoTypes[j]);
            }
          }
          photo.photoTypes = newTypeList;
        }
      }
      newPhotos.push(photo);
    }
    return newPhotos;
  };

  /**
   * setPhotoNum
   * @param photoType photoType
   * @param photoId photoId
   * @returns newPhotos
   */
  setPhotoNum = (
    photoType: { type: PhotoItemJson, num: number },
    photoId: string,
  ) => {
    const newPhotos = [];
    for (let i = 0; i < this.purchasePhotos.length; i += 1) {
      const photo = { ...this.purchasePhotos[i] };
      if (this.purchasePhotos[i].id === photoId) {
        for (let j = 0; j < photo.photoTypes.length; j += 1) {
          if (photo.photoTypes[j].type.photoItemId === photoType.type.photoItemId) {
            photo.photoTypes[j].num = photoType.num;
            break;
          }
        }
      }
      newPhotos.push(photo);
    }
    return newPhotos;
  };
}
